import { Reducer } from 'redux';
import { DistributorUserTypes, InitialDistributorUser } from './types';

const INITIAL_STATE: InitialDistributorUser = {
  distributorUserType: '',
  email: '',
  username: '',
  status: '',
};

const reducer: Reducer<InitialDistributorUser> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case DistributorUserTypes.GET_DISTRIBUTOR_USER:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export default reducer;
